import { ConsumptionVariance } from '@app/models/dyeing-dashboard/batch-consumption-estimate';

/** Same threshold the NT recipe-values screen flags a line at (`CycleRecipeValuesComponent.hasHighVariance`). */
export const HIGH_CONSUMPTION_VARIANCE_PERCENT = 20;

/** Null when there is no estimate to compare against; a missing actual counts as nothing consumed. */
export function getConsumptionVariance(
  estimated: number | null | undefined,
  actual: number | null | undefined,
): ConsumptionVariance | null {
  if (estimated == null) return null;

  const difference = (actual ?? 0) - estimated;
  const differencePercent = estimated !== 0 ? (difference / estimated) * 100 : null;

  return {
    estimated,
    difference,
    differencePercent,
    isHigh: differencePercent === null ? difference !== 0 : Math.abs(differencePercent) > HIGH_CONSUMPTION_VARIANCE_PERCENT,
  };
}
